export default __webpack_public_path__ + "static/media/penyesuaian.282efd92.png";